var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text-center"},[_c('p',{staticClass:"font-italic"},[_vm._v("Read all the terms of conditions")]),_c('a',{staticClass:"btn btn-primary",attrs:{"href":`/public/docs/ins4models-terms_and_conditions_${new Date().getFullYear()}.pdf`,"target":"_blank"}},[_vm._v(" Policy conditions Pdf ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }